module.exports = __webpack_public_path__ + "media/images/icons/justify-center-2e38e524a4ec15e9d8b68bf7d8bbf79d.svg";